import { render, staticRenderFns } from "./Fanzones.vue?vue&type=template&id=56891e68&"
import script from "./Fanzones.vue?vue&type=script&lang=js&"
export * from "./Fanzones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports